// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92f30b93","732":"55e1b872","977":"a7ec1758"}[chunkId] + ".chunk.js";
};